import * as React from "react";

import { LayoutContext, LayoutContextType } from "./FormLayoutContext";

const FormLayout: React.FunctionComponent<LayoutContextType> = ({ children, ...rest }) => {
  return <LayoutContext.Provider value={rest}>{children}</LayoutContext.Provider>;
};

export default FormLayout;
